// extracted by mini-css-extract-plugin
export default {"wrapper":"docs-container_wrapper__mvbyY"};